import { DeliveryType } from "./types";

export const DELIVERY_TYPES: DeliveryType[] = [
  {
    type: "IMAGE",
    label: "Images",
    isDisabled: false,
  },
  {
    type: "DOCUMENT",
    label: "Documents",
    isDisabled: import.meta.env.VITE_ENV === "prod",
  },
  {
    type: "VIDEO",
    label: "Motion media",
    isDisabled: false,
  },
  {
    type: "DELIVERY",
    label: "Delivery (Coming soon)",
    isDisabled: true,
  },
];
